<template>
  <div class="col-span-6">
    <label for="field.label" class="block 2xl:text-sm sm:text-xl font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <ul class="mt-1 relative list-disc">
      <li class="ml-4 2xl:text-sm sm:text-xl" :key="item" v-for="item in label">{{item}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'legend-list-field',
  data() {
    return {
      label: [],
      dependentdata: {}
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    params: {
      field: {
        type: Object
      }
    },
    formdata: {
      field: {
        type: Object,
        required: true,
      }
    },

  },

  created() {
    this.checkDepends()
  },

  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal) {
        if (this.field.depends !== '' && this.field.depends !== undefined) {
          if ( typeof this.dependentdata[this.field.depends] === 'object'){
            if (this.field.depends in newVal) {
              if (JSON.stringify(this.dependentdata[this.field.depends]) !== JSON.stringify(newVal[this.field.depends])) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                await this.getValues()
              }
            }else{
              this.label = []
            }
          }else {
            if (this.field.depends in newVal) {
              if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                await this.getValues()
              }
            }else{
              this.label = []
            }
          }
        }
      }
    }
  },

  methods: {
    checkDepends() {
      if (this.field.depends === undefined || this.field.depends === "") {
        this.getValues()
      }
      this.label = []
    },
    async getValues() {
      let config = {
        params: {
          legend: true,
          ...this.params,
          ...this.formdata,
          formdata: this.formdata
        }
      }

      const response = await this.$http.get(this.field.uri, config)
      var payload = response.data[this.field.key]
      console.log(payload);
      this.label = payload[this.field.options_label ? this.field.options_label : 'value']
      this.$parent.updateValue(this.field.key, payload[this.field.options_value ? this.field.options_value : 'value'])

    },
  }
}
</script>
